module.exports = __webpack_public_path__ + "873822935752a7591dae4c272d63ad10.pdf";